import { Container } from "@mui/material";
import React, { useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/Add";
import styled from "@emotion/styled";
const WrapperAccordian = styled(Accordion)`
  /* border-bottom: 1px solid #fff; */
  margin: 10px 0;
  padding: 10px 20px;
  max-width: 100%;
  background-color: #001524;
  color: #fff;
  font-family: "P-SB";
  border-radius:17px !important;

`;
const PlusIcons = styled(AddCircleOutlineOutlinedIcon)`
border-radius:7px;
/* background-color:#151515; */
color: #fff;
`
const Div = styled.div`
text-align: -moz-center;
text-align: -webkit-center;
`;
const AccordianMain = () => {
  const [expanded, setExpanded] = useState("false");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Div>
      <WrapperAccordian expanded={expanded === "panel1"}onChange={handleChange("panel1")}>
        <AccordionSummary
          expandIcon={<PlusIcons/>}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ fontFamily: "P-SB",textAlign:"left",   textTransfom: "uppercase", width: "100%", flexShrink: 0 }}>
          What is PulseOTC?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{textAlign:"left", fontFamily: "P-SB",  width: "100%", flexShrink: 0 }}>
          Pulse OTC is a platform for swapping Ethereum for $Pulse on the Pulse network.

          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
     
      <WrapperAccordian
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<PlusIcons/>}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography sx={{textAlign:"left",fontFamily: "P-SB",   width: "100%", flexShrink: 0 }}>
          How OTC works?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ textAlign:"left", fontFamily: "P-SB", width: "100%", flexShrink: 0 }}>
          OTC (Over-the-Counter) works by allowing buyers and sellers to trade cryptocurrencies directly with each other without the need for an exchange.
 </Typography>
        </AccordionDetails>
      </WrapperAccordian>
      
     
    </Div>
  );
};

export default AccordianMain;
